import React, { useState } from "react";
import "./style.css";
import classNames from "classnames";
import Button from "public/shared/ui/inputs/classicButton.js";
/**
 * Invoking this function will display a confirmation dialog to the user.
 */
export let confirm;
export default function ConfirmationManager() {
    const [activeConfirmation, setActiveConfirmation] = useState();
    const [isOpen, setIsOpen] = useState(false);
    confirm = (options) => {
        return new Promise((resolve) => {
            setIsOpen(true);
            setActiveConfirmation({ resolve, options });
        });
    };
    return (React.createElement("div", { className: "confirmation-manager-container" },
        React.createElement("div", { className: classNames("confirmation-dialog", {
                "confirmation-dialog--active": isOpen,
            }) },
            React.createElement("section", null, activeConfirmation && (React.createElement(React.Fragment, null,
                React.createElement("h3", null, activeConfirmation.options.title),
                React.createElement("p", null, activeConfirmation.options.message),
                React.createElement("div", { className: "confirmation-dialog-buttons" },
                    React.createElement(Button, { version: "alternative", onClick: () => {
                            activeConfirmation.resolve(false);
                            setIsOpen(false);
                        } }, "Anuluj"),
                    React.createElement(Button, { version: "classic", onClick: () => {
                            activeConfirmation.resolve(true);
                            setIsOpen(false);
                        } }, activeConfirmation.options.confirmButton || "Potwierdź"))))))));
}
